module.exports = __webpack_public_path__ + "img/57ff64d.png";